import axios from 'axios';

const BASE_URL = "/admin/auth/settings/translation";

export async function loadTranslationSettings() {
  try {
    const { data } = await axios.get(`${BASE_URL}/get-settings`);
    return {
      glossary: data.glossary || [],
      exclude: data.exclude || [],
    };
  } catch (error) {
    console.error("Failed to load translation settings", error);
    return { glossary: [], exclude: [] };
  }
}

export async function saveGlossaryEntry(entry) {
  const { data } = await axios.post(`${BASE_URL}/glossary`, entry);
  return data;
}

export async function deleteGlossaryEntry(id) {
  await axios.delete(`${BASE_URL}/glossary/${id}`);
}

export async function saveExcludeTerm(term) {
  const { data } = await axios.post(`${BASE_URL}/exclude`, { term });
  return data;
}

export async function deleteExcludeTerm(term) {
  await axios.delete(`${BASE_URL}/exclude`, { data: { term } });
}

export async function importTranslationSettings(file) {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(`${BASE_URL}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
}

export async function exportGlossary(language) {
  const { data } = await axios.get(`${BASE_URL}/export-glossary`, {
    params: { language },
    responseType: "blob",
  });
  return data;
}

export async function exportExclude() {
  const { data } = await axios.get(`${BASE_URL}/export-exclude`, {
    responseType: "blob",
  });
  return data;
}
